import Nullstack from 'nullstack';
export default function IconAdOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ad-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 5h10a2 2 0 0 1 2 2v10m-2 2h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M7 15v-4a2 2 0 0 1 2 -2m2 2v4"
  }), "   ", Nullstack.element("path", {
    d: "M7 13h4"
  }), "   ", Nullstack.element("path", {
    d: "M17 9v4"
  }), "   ", Nullstack.element("path", {
    d: "M16.115 12.131c.33 .149 .595 .412 .747 .74"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}